import * as DisclosureType from '../constants/disclosureType';

class AssessmentSuccessController{
    constructor(preFetchedData) {
        this.displayId = preFetchedData.disclosureData.displayId;
        this.disclosureType = preFetchedData.disclosureData.disclosureType;
        this.successMessage = `The ${this.disclosureType === DisclosureType.CONFLICT ? 'Management' : 'Gift'} Strategy for ${this.disclosureType === DisclosureType.CONFLICT ? 'COI' : 'gift'} ID ${this.displayId} is pending review by the Integrity and Standards Unit.`;
    }

    $onInit() {
    }
}

AssessmentSuccessController.$inject = ['preFetchedData'];

export default AssessmentSuccessController;


// WEBPACK FOOTER //
// ./app/assess/assessment-success.controller.js